import { renderToStaticMarkup } from 'react-dom/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icons } from '../../../constants/customIcons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fas, far);
/**
 *
 * @param {*} cssClass = Css class that will be added only to the FontAwesome Icon. Usually, this props is used to define the color of the icon. The classes that can be used are initialized in scss/elements/icons.scss
 * @param {*} iconColor = This holds the iconColor only for CUSTOM Icons. Can be HEX or normal css colors.
 * @param {*} iconName = The icon name to be shown. For custom icons, specify the name of the custom icons ( saved in customIcons.js ). For font awesome icons ONLY use the name of the icon. (e.g case: <i class="fa-solid fa-xmark"></i> iconName: 'xmark')
 * @param {*} type = The type of the fontawesome icon. (e.g ['far', 'fal', 'fas']). For more types update the fontawesomeTypeEnum
 * @param {*} size = The size of the icon, only used for fontawesome icons.
 * @param {*} clickHandler = Callback triggered by clicking on the icon.
 * @param {*} direct = if true, name of icon can directly be typed in inside icon. False per pefault
 * @returns This component renders CUSTOM ICONS AND FONTAWESOME ICONS. CUSTOM ICONS ARE SAVED IN /CONSTANTS/CUSTOMICONS.js.
 */
function Icon({ direct = false, iconColor = 'black', iconName, cssClass = '', type, size, clickHandler }) {
	cssClass = cssClass + ' icon';

	const customIcons = new Icons(iconColor).iconConfigTeakEntityFeatures;

	//const fontawesomeTypeEnum = ['far', 'fal', 'fas'];
	//let fontawesomeIcon = type ? [type, iconName] : iconName;

	// please check the link https://fontawesome.com/v5.15/how-to-use/on-the-web/using-with/react
	// in future this can be changed to something smarter ;)
	// if (!fontawesomeIcon) return null;
	// if (fontawesomeIcon?.includes('fab')) {
	// 	fontawesomeIcon = [iconName.substring(0, 3), iconName.substring(7)];
	// } else if (fontawesomeTypeEnum.includes(iconName.substring(0, 3))) {
	// 	fontawesomeIcon = [iconName.substring(0, 3), iconName.substring(7)];
	// }

	if (direct === true) {
		return (
			<FontAwesomeIcon
				className={cssClass}
				icon={iconName || 'bullseye'}
				size={size}
				onClick={clickHandler}
			></FontAwesomeIcon>
		);
	}
	else if (customIcons[iconName]?.custom) {
		return (
			<div
				className={'custom-icon ' + cssClass}
				dangerouslySetInnerHTML={{
					__html: customIcons[iconName].custom,
				}}
				onClick={clickHandler}
			/>
		);
	} else if (customIcons[iconName]?.fontawesome) {
		return (
			<FontAwesomeIcon
				className={cssClass}
				icon={customIcons[iconName]?.fontawesome || 'bullseye'}
				size={size}
				onClick={clickHandler}
			/>
		);
	}

	if (iconName === 'small' || iconName === 'medium' || iconName === 'large' || iconName === 's' || iconName === 'm' || iconName === 'l') {
		return <div className={cssClass + ' size-icon'}>{iconName.charAt(0).toUpperCase()}</div>;
	} else {
		return (
			iconName ? (
			<FontAwesomeIcon
				className={cssClass}
				icon={iconName === 'none' ? 'bullseye' : iconName} // some icons have iconName 'none' in DB
				size={size}
				onClick={clickHandler}></FontAwesomeIcon>
			) : null
		);
	}
}

//check if the icon can be rendered or not
export function isIconValid(iconName) {
	return Boolean(renderToStaticMarkup(<Icon iconName={iconName} />));
}

export function getTeakTypeIconName(iconName) {
	if (isIconValid(iconName)) {
		return iconName;
	} else {
		return 'customTeakType';
	}
}
export default Icon;
